import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationMessagesPipe } from './pipes/translation-msg.pipe';
import { StrictValuePipe } from './pipes/strict-value.pipe';
import { CurrencyValuePipe } from './pipes/currency.pipe';
import { DateValuePipe } from './pipes/date-value.pipe';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  AuthRepositoryModule,
  CalculatorRepositoryModule,
  DocumentRepositoryModule,
  ParcelRepositoryModule,
  PolicyRepositoryModule,
} from '../client/repositories';
import { ScrollSpyDirective } from './foundation/directives/scroll-spy.directive';
import { ClaimRepositoryModule } from '../client/repositories/claim/claim.module';
import { ContentLayoutComponent } from '../containers/layout/content-layout.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UserMessageRepositoryModule } from '../client/repositories/user-message';
import { UserRepositoryModule } from '../client/repositories/user/user.module';
import { ContentLayoutV2Component } from '../containers/layout/content-layout-v2.component';
import { AddressChangeRequestModule } from '../client/repositories/address-change-request/address-change-request.module';
import { CustomerRequestRepositoryModule } from '../client/repositories/customer-request';

const MODULES: any[] = [
  CommonModule,
  RouterModule,
  FormsModule,
  FlexLayoutModule,
  ReactiveFormsModule,
  NgbDatepickerModule,
  AngularSvgIconModule.forRoot(),
];

const SERVICES: any[] = [];

const MODULES_EXPORT = [
  CommonModule,
  RouterModule,
  FormsModule,
  FlexLayoutModule,
  ReactiveFormsModule,
  NgbDatepickerModule,
  ClaimRepositoryModule,
  AddressChangeRequestModule,
  CustomerRequestRepositoryModule,
  DocumentRepositoryModule,
  ParcelRepositoryModule,
  ClaimRepositoryModule,
  CalculatorRepositoryModule,
  UserMessageRepositoryModule,
  UserRepositoryModule,
  PolicyRepositoryModule,
  CustomerRequestRepositoryModule,
];

const COMPONENTS: any[] = [ContentLayoutComponent, ContentLayoutV2Component];

const DIRECTIVES = [ScrollSpyDirective];

const PIPES = [
  TranslationMessagesPipe,
  StrictValuePipe,
  CurrencyValuePipe,
  DateValuePipe,
];

@NgModule({
  imports: [...MODULES],
  exports: [...DIRECTIVES, ...PIPES, ...COMPONENTS, ...MODULES_EXPORT],
  declarations: [...DIRECTIVES, ...PIPES, ...COMPONENTS],
  providers: [...SERVICES, ...PIPES],
})
export class SharedModule {}
